import { Scenes } from '../../app/rendering-3d/models/scenes.enum';
import { allPointers } from './pointers/all.pointers';
import { allFrames } from './frames/all.frames';

export const startOnScene = Scenes.Scene1;

// order depends on { Scenes } from '../../app/rendering-3d/models/scenes.enum'
export const scenesLinks: any = [
  {
    name: 'Floor',
    scene: Scenes.FloorPlan,
    pointers: allPointers.floorPlanPointers,
    // fixed: can't click anything when going from floor plan
    frames: [],
    initialState: {
      yaw: -1  * Math.PI / 180,
      pitch: 1 * Math.PI / 180,
      fov: 70 * Math.PI / 180
    },
  },

/////////////////////////////////////

  {
    name: 'Scene1',
    scene: Scenes.Scene1,
    pointers: allPointers.scene1Pointers,
    frames: [...allFrames.scene1Frames],
    initialState: {
      yaw: 88 * Math.PI / 180,
      pitch: -2.8 * Math.PI / 180,
    },
  },
  {
    name: 'Scene2',
    scene: Scenes.Scene2,
    frames: [...allFrames.scene2Frames],
    pointers: allPointers.scene2Pointers,
    initialState: {
      yaw: 6.4 * Math.PI / 180,
      pitch: -3.7 * Math.PI / 180,
    },
  },
  {
    name: 'Scene3',
    scene: Scenes.Scene3,
    initialState: {
      yaw: -1.8 * Math.PI / 180,
      pitch: -3.1 * Math.PI / 180,
    },
    frames: [...allFrames.scene3Frames],
    pointers: allPointers.scene3Pointers
  },
  {
    name: 'Scene4',
    scene: Scenes.Scene4,
    pointers: allPointers.scene4Pointers,
    frames: [...allFrames.scene4Frames],
    initialState: {
      yaw: 84.2 * Math.PI / 180,
      pitch: -3.3 * Math.PI / 180,
    },
  }
];
